"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var tabs_1 = __importDefault(require("relements/build/esm/ui/tabs"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var platformDeployment_1 = require("@src/containers/BusinessManager/utils/validators/schemas/platformDeployment");
var sdkConfiguration_1 = require("@src/containers/BusinessManager/utils/validators/schemas/sdkConfiguration");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var api_1 = require("@src/api");
var InfoTooltip_1 = __importDefault(require("@src/components/InfoTooltip"));
var utils_1 = require("@src/utils");
var _utils_1 = require("@src/actions/_utils");
var ViewCredentials_1 = __importDefault(require("../ViewCredentials"));
var TabContainer_1 = __importDefault(require("../../components/TabContainer"));
var LoginIntegration_1 = __importDefault(require("./FacebookLogin/LoginIntegration"));
var constants_1 = __importDefault(require("./constants"));
var utils_2 = require("./utils");
var maps_1 = require("./maps");
require("./Channels.scss");
var defaultChatIconConfig = {
    type: 'default',
    data: {
        imageURL: '',
    },
};
var defaultLanguageIconConfig = {
    type: 'global',
    data: {
        imageURL: '',
    },
};
var defaultSoundNotification = {
    type: 'default',
    data: {
        audioURL: '',
    },
};
var defaultMessageSound = {
    type: 'no',
    data: {
        audioURL: '',
    },
};
var defaultOmnichannelWidget = [
    {
        type: 'whatsapp',
        enabled: false,
    },
    {
        type: 'messenger',
        enabled: false,
    },
    {
        type: 'instagram',
        enabled: false,
    },
];
var initialState = {
    activeTab: constants_1["default"].TABS.CHANNEL_PATHS.SDK_CONFIGURATIONS,
    activeDeploymentOption: constants_1["default"].TABS.DEPLOYMENT_PATHS.FACEBOOK,
    deployments: [],
    callback_base_url: '',
    fb_app_id: '',
    sdkConfig: {
        whiteListedDomains: [],
        businessIcon: '',
        businessActive: true,
        showHaptikBranding: true,
        primaryColor: { value: 'CUSTOM' },
        primaryColor2: '#2DACF0',
        widgetPositioning: { value: 'bottom-right' },
        mode: { value: 'ssm' },
        chatIconConfig: defaultChatIconConfig,
        languageIconConfig: defaultLanguageIconConfig,
        omnichannelWidget: defaultOmnichannelWidget,
        botType: { value: 'TEXT' },
        disabled: [],
        language_config: {
            en: {
                headerText: 'Haptik',
                buttonText: "Let's Chat!",
                buttonTextDesktop: "Let's Chat!",
                buttonTextMobile: "Let's Chat!",
                fontFamily: 'Roboto',
                previewText: '',
                composerPlaceholder: 'Type here...',
            },
        },
        fontSize: '14px',
        customSignup: { value: false },
        customSignupIdentifier: 'guest',
        baseUrl: 'https://staging.hellohaptik.com',
        customButton: { value: false },
        customButtonIdentifier: '',
        voiceBotInitialInput: 'VOICE',
        gdpr: { value: false },
        showTypingSuggestions: { value: 'never' },
        disablePreviousButtons: { value: false },
        showAgentChatHistory: { value: false },
        showTimestamp: { value: true },
        showReferencesSection: { value: true },
        showReferencesCaptionSection: { value: true },
        disableBotPromptSound: { value: false },
        botPromptSoundUrl: defaultSoundNotification,
        enableMessageNotificationSound: { value: false },
        messageNotificationSoundUrl: defaultSoundNotification,
        botMessageSound: defaultMessageSound,
        userMessageSound: defaultMessageSound,
        showUserFeedback: { value: false },
        showFeedbackPopoverInstantly: { value: false },
        userFeedbackTagsPositive: [],
        userFeedbackTagsNegative: [],
        userFeedbackQuestionPositive: '',
        userFeedbackQuestionNegative: '',
        webhook_enabled: false,
        language_list: [],
        select_language: {},
        showAgentData: { value: true },
        skipAutoScrollToBottom: { value: true },
        openLinksUsing: { value: 'default' },
    },
    isDeploymentEdited: false,
    isSdkEdited: false,
    isEdited: false,
    isLoaderActive: false,
    isViewCredentialsModalOpen: false,
    errorOccurredWhileFetching: false,
};
function reducer(state, action) {
    switch (action.type) {
        case constants_1["default"].ActionTypes.SET_ACTIVE_TAB:
            return __assign(__assign({}, state), { activeTab: action.data });
        case constants_1["default"].ActionTypes.SET_ACTIVE_DEPLOYMENT_OPTION:
            return __assign(__assign({}, state), { activeDeploymentOption: action.data });
        case constants_1["default"].ActionTypes.SET_DEPLOYMENTS:
            return __assign(__assign({}, state), { deployments: action.data.body, callback_base_url: action.data.meta.callback_base_url, fb_app_id: action.data.meta.fb_app_id });
        case constants_1["default"].ActionTypes.SET_SDK_CONFIG:
            return __assign(__assign({}, state), { sdkConfig: __assign({}, action.data) });
        case constants_1["default"].ActionTypes.UPDATE_SELECTED_LANGUAGE:
            return __assign(__assign({}, state), { sdkConfig: __assign(__assign({}, state.sdkConfig), { select_language: action.data }) });
        case constants_1["default"].ActionTypes.UPDATE_SDK_DATA:
            return __assign(__assign({}, state), { sdkConfig: __assign(__assign({}, state.sdkConfig), action.data), isSdkEdited: true, isEdited: true });
        case constants_1["default"].ActionTypes.UPDATE_DEPLOYMENT_DATA:
            return __assign(__assign(__assign({}, state), action.data), { isDeploymentEdited: true, isEdited: true });
        case constants_1["default"].ActionTypes.TOGGLE_LOADER:
            return __assign(__assign({}, state), { isLoaderActive: typeof action.data !== 'undefined'
                    ? action.data
                    : !state.isLoaderActive });
        case constants_1["default"].ActionTypes.TOGGLE_FETCH_ERROR:
            return __assign(__assign({}, state), { errorOccurredWhileFetching: typeof action.data !== 'undefined'
                    ? action.data
                    : !state.errorOccurredWhileFetching });
        case constants_1["default"].ActionTypes.SET_DEPLOYMENT_EDITED_FALSE:
            return __assign(__assign({}, state), { isDeploymentEdited: false });
        case constants_1["default"].ActionTypes.SET_SDK_EDITED_FALSE:
            return __assign(__assign({}, state), { isSdkEdited: false });
        case constants_1["default"].ActionTypes.DATA_SAVED:
            return __assign(__assign({}, state), { isEdited: false, isSdkEdited: false, isDeploymentEdited: false });
        case constants_1["default"].ActionTypes.TOGGLE_VIEW_CREDENTIALS_MODAL:
            return __assign(__assign({}, state), { isViewCredentialsModalOpen: !state.isViewCredentialsModalOpen });
        default:
            return state;
    }
}
var LANGUAGE_SPECIFIC_KEYS = [
    'headerText',
    'buttonText',
    'buttonTextDesktop',
    'buttonTextMobile',
    'composerPlaceholder',
    'fontFamily',
    'previewText',
];
var NON_CREDENTIAL_KEYS = ['active', 'callback_url', 'consumer_identifier'];
var Channels = function () {
    var _a = react_redux_1.useSelector(maps_1.stateToProps), businessId = _a.businessId, businessViaName = _a.businessViaName, activePartners = _a.activePartners;
    var _b = react_1["default"].useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    react_1["default"].useEffect(function () {
        fetchChannelsData();
    }, [businessId]);
    react_1["default"].useEffect(function () {
        _utils_1.setEnableWhatsappPayFlag(businessViaName);
    }, [businessViaName]);
    var fetchChannelsData = function () {
        dispatch({ type: constants_1["default"].ActionTypes.TOGGLE_FETCH_ERROR, data: false });
        dispatch({ type: constants_1["default"].ActionTypes.TOGGLE_LOADER, data: true });
        Promise.all([
            api_1.API.businessV2
                .getSDKConfig(businessId)
                .then(function (_a) {
                var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                var success = _a.success, response = _a.response;
                if (!success) {
                    maps_1.createAlert(response.error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    return false;
                }
                var selectLanguage = ((_b = response.meta) === null || _b === void 0 ? void 0 : _b.language_list) &&
                    Array.isArray(response.meta.language_list) &&
                    response.meta.language_list.length !== 0
                    ? response.meta.language_list[0]
                    : {};
                // we only use the "5" key for configuration
                // referenced from v1
                var WEB_SDK_ID = 5;
                // setting default value if the key is not present in api response
                var chatIconConfigData = response.body[WEB_SDK_ID]
                    .chatIconConfig
                    ? response.body[WEB_SDK_ID].chatIconConfig
                    : defaultChatIconConfig;
                var languageIconConfigData = response.body[WEB_SDK_ID].languageIconConfig
                    ? response.body[WEB_SDK_ID].languageIconConfig
                    : defaultLanguageIconConfig;
                var botPromptSoundConfigData = response
                    .body[WEB_SDK_ID].botPromptSoundUrl
                    ? response.body[WEB_SDK_ID].botPromptSoundUrl
                    : defaultSoundNotification;
                var messageNotificationSoundConfigData = response
                    .body[WEB_SDK_ID].messageNotificationSoundUrl
                    ? response.body[WEB_SDK_ID].messageNotificationSoundUrl
                    : defaultSoundNotification;
                var botMessageSoundConfigData = response
                    .body[WEB_SDK_ID].botMessageSound
                    ? response.body[WEB_SDK_ID].botMessageSound
                    : defaultMessageSound;
                var userMessageSoundConfigData = response
                    .body[WEB_SDK_ID].userMessageSound
                    ? response.body[WEB_SDK_ID].userMessageSound
                    : defaultMessageSound;
                // Show haptik branding setting only if haptik branding feature flag is enabled for business
                var showHaptikBrandingOption = _utils_1.showHaptikBrandingOptionCheck(businessViaName);
                var enableTypingSuggestions = response.body[WEB_SDK_ID].enableTypingSuggestions;
                var showTypingSuggestions = {
                    value: response.body[WEB_SDK_ID].showTypingSuggestions ||
                        (enableTypingSuggestions && 'only_menu') ||
                        'never',
                };
                var disablePreviousButtons = {
                    value: (_c = response.body[WEB_SDK_ID].disablePreviousButtons) !== null && _c !== void 0 ? _c : false,
                };
                var showAgentChatHistory = {
                    value: (_d = response.body[WEB_SDK_ID].showAgentChatHistory) !== null && _d !== void 0 ? _d : false,
                };
                var showTimestamp = {
                    value: (_e = response.body[WEB_SDK_ID].showTimestamp) !== null && _e !== void 0 ? _e : true,
                };
                var showReferencesSection = {
                    value: (_f = response.body[WEB_SDK_ID].showReferencesSection) !== null && _f !== void 0 ? _f : true,
                };
                var showReferencesCaptionSection = {
                    value: (_g = response.body[WEB_SDK_ID].showReferencesCaptionSection) !== null && _g !== void 0 ? _g : true,
                };
                var disableBotPromptSound = {
                    value: (_h = response.body[WEB_SDK_ID].disableBotPromptSound) !== null && _h !== void 0 ? _h : false,
                };
                var enableMessageNotificationSound = {
                    value: (_j = response.body[WEB_SDK_ID].enableMessageNotificationSound) !== null && _j !== void 0 ? _j : false,
                };
                var showAgentData = {
                    value: (_k = response.body[WEB_SDK_ID].showAgentData) !== null && _k !== void 0 ? _k : true,
                };
                var skipAutoScrollToBottom = {
                    value: (_l = response.body[WEB_SDK_ID].skipAutoScrollToBottom) !== null && _l !== void 0 ? _l : true,
                };
                var openLinksUsing = {
                    value: (_m = response.body[WEB_SDK_ID].openLinksUsing) !== null && _m !== void 0 ? _m : 'default',
                };
                var body = __assign(__assign(__assign({}, response.body[WEB_SDK_ID]), response.meta), { select_language: selectLanguage, chatIconConfig: chatIconConfigData, languageIconConfig: languageIconConfigData, businessIcon: response.body.image_url, businessActive: response.body.active, omnichannelWidget: response.body[WEB_SDK_ID].omnichannelWidget ||
                        defaultOmnichannelWidget, showHaptikBranding: !response.body.hide_branding, showHaptikBrandingOption: showHaptikBrandingOption, whiteListedDomains: ((_o = response.body) === null || _o === void 0 ? void 0 : _o.cors_origins) || [], 
                    // making them compatible to relements input format
                    disabled: response.body[WEB_SDK_ID].disabled.map(function (option) { return ({
                        value: option,
                    }); }), gdpr: { value: response.body[WEB_SDK_ID].gdpr }, primaryColor: { value: response.body[WEB_SDK_ID].primaryColor }, botType: { value: response.body[WEB_SDK_ID].botType }, customButton: { value: response.body[WEB_SDK_ID].customButton }, customSignup: { value: response.body[WEB_SDK_ID].customSignup }, showUserFeedback: {
                        value: response.body[WEB_SDK_ID].showUserFeedback,
                    }, showFeedbackPopoverInstantly: {
                        value: (_p = response.body[WEB_SDK_ID].showFeedbackPopoverInstantly) !== null && _p !== void 0 ? _p : false,
                    }, widgetPositioning: {
                        value: response.body[WEB_SDK_ID].widgetPositioning,
                    }, mode: { value: response.body[WEB_SDK_ID].mode }, showTypingSuggestions: showTypingSuggestions,
                    disablePreviousButtons: disablePreviousButtons,
                    showAgentChatHistory: showAgentChatHistory,
                    showTimestamp: showTimestamp,
                    showReferencesSection: showReferencesSection,
                    showReferencesCaptionSection: showReferencesCaptionSection,
                    disableBotPromptSound: disableBotPromptSound, botPromptSoundUrl: botPromptSoundConfigData, botMessageSound: botMessageSoundConfigData, userMessageSound: userMessageSoundConfigData, enableMessageNotificationSound: enableMessageNotificationSound, messageNotificationSoundUrl: messageNotificationSoundConfigData, showAgentData: showAgentData,
                    skipAutoScrollToBottom: skipAutoScrollToBottom,
                    openLinksUsing: openLinksUsing });
                dispatch({
                    type: constants_1["default"].ActionTypes.SET_SDK_CONFIG,
                    data: __assign({}, body),
                });
                return true;
            }),
            api_1.API.businessV2
                .getDeployments(businessId)
                .then(function (_a) {
                var success = _a.success, body = _a.body, meta = _a.meta, error = _a.error;
                if (!success) {
                    maps_1.createAlert(error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    return false;
                }
                if (body && Array.isArray(body)) {
                    dispatch({
                        type: constants_1["default"].ActionTypes.SET_DEPLOYMENTS,
                        data: {
                            body: body,
                            meta: meta,
                        },
                    });
                }
                return true;
            }),
        ])
            .then(function (responses) {
            dispatch({ type: constants_1["default"].ActionTypes.TOGGLE_LOADER });
            responses.forEach(function (response) {
                if (!response) {
                    dispatch({
                        type: constants_1["default"].ActionTypes.TOGGLE_FETCH_ERROR,
                        data: true,
                    });
                }
            });
        })["catch"](function (error) {
            dispatch({ type: constants_1["default"].ActionTypes.TOGGLE_LOADER });
            dispatch({
                type: constants_1["default"].ActionTypes.TOGGLE_FETCH_ERROR,
                data: true,
            });
            api_1.captureException(error);
        });
    };
    var handleTabChange = react_1["default"].useCallback(function (forDeployment) { return function (newTab) {
        if (forDeployment) {
            dispatch({
                type: constants_1["default"].ActionTypes.SET_ACTIVE_DEPLOYMENT_OPTION,
                data: newTab,
            });
        }
        else {
            dispatch({
                type: constants_1["default"].ActionTypes.SET_ACTIVE_TAB,
                data: newTab,
            });
        }
    }; }, []);
    var handleDeploymentChange = react_1["default"].useCallback(function (option) {
        dispatch({
            type: constants_1["default"].ActionTypes.SET_ACTIVE_DEPLOYMENT_OPTION,
            data: option.path,
        });
    }, []);
    var handleSDKUpdate = function (key) { return function (value) {
        var _a, _b, _c, _d, _e, _f;
        if (key === 'disableBotPromptSound' && value.value) {
            dispatch({
                type: constants_1["default"].ActionTypes.UPDATE_SDK_DATA,
                data: (_a = { botPromptSoundUrl: defaultSoundNotification }, _a[key] = value, _a),
            });
            return;
        }
        if (key === 'enableMessageNotificationSound' && !value.value) {
            dispatch({
                type: constants_1["default"].ActionTypes.UPDATE_SDK_DATA,
                data: (_b = {
                        messageNotificationSoundUrl: defaultSoundNotification
                    },
                    _b[key] = value,
                    _b),
            });
            return;
        }
        if (LANGUAGE_SPECIFIC_KEYS.includes(key)) {
            var languageCode = state.sdkConfig.select_language.language_code;
            if (languageCode) {
                dispatch({
                    type: constants_1["default"].ActionTypes.UPDATE_SDK_DATA,
                    data: {
                        language_config: __assign(__assign({}, state.sdkConfig.language_config), (_c = {}, _c[languageCode] = __assign(__assign({}, state.sdkConfig.language_config[languageCode]), (_d = {}, _d[key] = value, _d)), _c)),
                    },
                });
                return;
            }
            return;
        }
        if (key === 'select_language') {
            dispatch({
                type: constants_1["default"].ActionTypes.UPDATE_SELECTED_LANGUAGE,
                data: value,
            });
            return;
        }
        var WIDGETS = ['whatsapp_widget', 'facebook_widget', 'instagram_widget'];
        if (WIDGETS.includes(key)) {
            dispatch({
                type: constants_1["default"].ActionTypes.UPDATE_SDK_DATA,
                data: __assign((_e = {}, _e[key] = value.toggleValue, _e), value.formData),
            });
            return;
        }
        dispatch({
            type: constants_1["default"].ActionTypes.UPDATE_SDK_DATA,
            data: (_f = {}, _f[key] = value, _f),
        });
    }; };
    var updateInstagramDeployment = react_1["default"].useCallback(function (platformId, instObj, active, saveDetails) {
        var deploymentData = state.deployments.filter(function (deployment) { return deployment.platform_id === platformId; });
        var updatedDeployments = __spreadArrays(state.deployments);
        var updatedKeys = __assign({}, deploymentData[0]);
        if (instObj) {
            updatedKeys = __assign(__assign({}, updatedKeys), { active: active, credentials: __assign(__assign({}, updatedKeys.credentials), instObj) });
        }
        updatedDeployments = updatedDeployments.filter(function (deployment) { return deployment.platform_id !== platformId; });
        updatedDeployments.push(updatedKeys);
        dispatch({
            type: constants_1["default"].ActionTypes.UPDATE_DEPLOYMENT_DATA,
            data: { deployments: updatedDeployments },
        });
        if (saveDetails) {
            api_1.API.businessV2
                .saveDeployments(businessId, updatedDeployments)
                .then(function (_a) {
                var body = _a.body;
                if (!body.success) {
                    maps_1.createAlert(body.error ||
                        'Error occurred while saving platform deployments', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    return false;
                }
                dispatch({
                    type: constants_1["default"].ActionTypes.SET_DEPLOYMENT_EDITED_FALSE,
                });
                dispatch({ type: constants_1["default"].ActionTypes.DATA_SAVED });
                return true;
            });
        }
    }, [state.deployments]);
    var handleDeploymentsUpdate = function (platformId) { return function (key) { return function (value) {
        var _a, _b, _c, _d, _e;
        var isArray = [
            'emails',
            'valid_keys',
            'welcome_messages',
            'deep_link_messages',
            'deep_link_messages_responses',
            'welcome_message_responses',
            'pre_checks_messages',
            'language_fetch_messages',
            'disambiguation_to_bot_break_messages',
            'hni_responses',
        ];
        var getValueAsArray = function () { return (Array.isArray(value) ? value : [value]); };
        var deploymentData = state.deployments.filter(function (deployment) { return deployment.platform_id === platformId; });
        var updatedDeployments = __spreadArrays(state.deployments);
        if (deploymentData.length) {
            var updatedKeys = __assign({}, deploymentData[0]);
            if (NON_CREDENTIAL_KEYS.includes(key)) {
                updatedKeys = __assign(__assign({}, updatedKeys), (_a = {}, _a[key] = value, _a));
            }
            else if (updatedKeys.credentials &&
                Object.keys(updatedKeys.credentials).length) {
                updatedKeys = __assign(__assign({}, updatedKeys), { credentials: __assign(__assign({}, updatedKeys.credentials), (_b = {}, _b[key] = isArray.includes(key) ? getValueAsArray() : value, _b)) });
                if (key === 'webhook_enabled') {
                    updatedKeys = __assign(__assign({}, updatedKeys), { credentials: __assign(__assign({}, updatedKeys.credentials), { webhook_email_alerts: updatedKeys.credentials.webhook_enabled }) });
                }
            }
            else {
                updatedKeys = __assign(__assign({}, updatedKeys), { credentials: (_c = {},
                        _c[key] = isArray.includes(key) ? getValueAsArray() : value,
                        _c) });
            }
            updatedDeployments = updatedDeployments.filter(function (deployment) { return deployment.platform_id !== platformId; });
            updatedDeployments.push(updatedKeys);
        }
        else {
            var newPlatform = {
                platform_id: platformId,
                business_id: businessId,
            };
            if (NON_CREDENTIAL_KEYS.includes(key)) {
                newPlatform = __assign(__assign({}, newPlatform), (_d = {}, _d[key] = value, _d));
            }
            else {
                newPlatform = __assign(__assign({}, newPlatform), { credentials: (_e = {},
                        _e[key] = isArray.includes(key) ? getValueAsArray() : value,
                        _e) });
            }
            updatedDeployments.push(newPlatform);
        }
        dispatch({
            type: constants_1["default"].ActionTypes.UPDATE_DEPLOYMENT_DATA,
            data: { deployments: updatedDeployments },
        });
    }; }; };
    var renderBlock = function (block, className, inputValues, getInputValue, getInputProps, handleOnChange, disabled) {
        if (className === void 0) { className = ''; }
        if (inputValues === void 0) { inputValues = {}; }
        if (getInputValue === void 0) { getInputValue = function (key, inputValues, inputProps) { }; }
        if (getInputProps === void 0) { getInputProps = function (input, inputValues) { }; }
        if (handleOnChange === void 0) { handleOnChange = function (key) { }; }
        if (disabled === void 0) { disabled = false; }
        return (react_1["default"].createElement("div", { className: block.className || 'channels-block' },
            block.title && react_1["default"].createElement("div", { className: "channels-block-title" }, block.title),
            react_1["default"].createElement("div", { className: className }, block.inputs.map(function (input) {
                var InputComponent = input.component;
                var inputProps = getInputProps(input, inputValues);
                var inputValue = getInputValue(input.key, inputValues, inputProps);
                if (inputProps.invisible)
                    return null;
                return (react_1["default"].createElement(InputComponent, __assign({ className: input.className || 'channels-block-input', label: input.label || 'Label Missing', value: inputValue, disabled: disabled, onChange: handleOnChange(input.key) }, inputProps)));
            }))));
    };
    var getSDKConfigurationsInputs = function () {
        var blocks = constants_1["default"].INPUTS[constants_1["default"].TABS.CHANNEL_PATHS.SDK_CONFIGURATIONS].blocks;
        if (!Array.isArray(blocks))
            return null;
        return (react_1["default"].createElement("div", { className: "channels-wrapper" }, blocks.map(function (block) {
            return renderBlock(block, '', state, getSDKConfigValue, getSDKConfigProps, handleSDKUpdate, utils_1.isProduction());
        })));
    };
    var renderDeploymentInputs = function (inputValue) {
        var activeDeploymentOption = state.activeDeploymentOption;
        var _a = constants_1["default"].INPUTS[activeDeploymentOption] || {}, id = _a.id, blocks = _a.blocks;
        if (activeDeploymentOption === 'Instagram') {
            return (react_1["default"].createElement(LoginIntegration_1["default"], { storedValues: inputValue, updateDeploymentValues: updateInstagramDeployment, platformId: id, appId: state.fb_app_id }));
        }
        return Array.isArray(blocks) ? (react_1["default"].createElement(react_1["default"].Fragment, null, blocks.map(function (block) {
            return renderBlock(block, 'channels-block-deployments', inputValue, getPlatformDeploymentsValue, getPlatformDeploymentsProps, handleDeploymentsUpdate(id));
        }))) : (react_1["default"].createElement("div", null, "No input fields present."));
    };
    var getSDKConfigProps = function (input) {
        if (input.key === 'select_language') {
            return __assign(__assign({}, input.props), { options: state.sdkConfig.language_list });
        }
        return typeof input.props !== 'function'
            ? input.props || {}
            : input.props(state.sdkConfig);
    };
    var getSDKConfigValue = function (key, inputValues, inputProps) {
        if (LANGUAGE_SPECIFIC_KEYS.includes(key)) {
            if (state.sdkConfig.select_language.language_code) {
                return state.sdkConfig.language_config[state.sdkConfig.select_language.language_code][key];
            }
            return undefined;
        }
        if (inputProps.options && key !== 'disabled')
            return utils_2.getValueFromOptions(inputValues.sdkConfig[key], inputProps.options);
        return inputValues.sdkConfig[key];
    };
    var getPlatformDeploymentsValue = function (key, inputValues) {
        var _a = inputValues.credentials, credentials = _a === void 0 ? {} : _a;
        if (key === 'callback_url') {
            return "" + state.callback_base_url + inputValues[key];
        }
        if (!NON_CREDENTIAL_KEYS.includes(key)) {
            return credentials[key];
        }
        return inputValues[key];
    };
    var getPlatformDeploymentsProps = function (input, inputValues) {
        return typeof input.props !== 'function'
            ? input.props || {}
            : input.props(state.deployments, inputValues);
    };
    var getPlatformDeploymentsInput = function () {
        var activeDeploymentOption = state.activeDeploymentOption;
        var _a = constants_1["default"].INPUTS[activeDeploymentOption] || {}, blocks = _a.blocks, id = _a.id;
        var deploymentData = state.deployments.filter(function (deployment) { return deployment.platform_id === id; });
        var inputValue = {};
        if (deploymentData.length) {
            inputValue = __assign({}, deploymentData[0]);
        }
        var selectedDeploymentOption = constants_1["default"].TABS.DEPLOYMENT_OPTIONS.find(function (item) {
            return item.path === activeDeploymentOption;
        });
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(dropdown_1["default"], { options: constants_1["default"].TABS.DEPLOYMENT_OPTIONS, value: selectedDeploymentOption === null || selectedDeploymentOption === void 0 ? void 0 : selectedDeploymentOption.title, onChange: handleDeploymentChange, optionKey: "title", searchKey: "title", label: "Platform", className: "channels-deployments-dropdown", withSearch: true }),
            react_1["default"].createElement("div", { className: "channels-wrapper" },
                !utils_1.isProduction() && (react_1["default"].createElement("div", { className: "channels-infotip" },
                    react_1["default"].createElement(InfoTooltip_1["default"], null,
                        react_1["default"].createElement("div", { className: "channels-infotip-text" }, "The deployment settings are not published to production.")))),
                renderDeploymentInputs(inputValue))));
    };
    var getActiveTabInputs = function () {
        switch (state.activeTab) {
            case constants_1["default"].TABS.CHANNEL_PATHS.SDK_CONFIGURATIONS:
                return getSDKConfigurationsInputs();
            case constants_1["default"].TABS.CHANNEL_PATHS.PLATFORM_DEPLOYMENTS:
                return getPlatformDeploymentsInput();
            default:
                return null;
        }
    };
    var handleOnSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var apiPromise, isValid_1, _a, _b, _i, deployment, deploymentObject, creds, isValid_2, sdkConfig, deployments, commonConfig, sdkData;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!state.isEdited || state.errorOccurredWhileFetching)
                        return [2 /*return*/];
                    dispatch({ type: constants_1["default"].ActionTypes.TOGGLE_LOADER, data: true });
                    apiPromise = [];
                    if (!state.isDeploymentEdited) return [3 /*break*/, 6];
                    isValid_1 = true;
                    _a = [];
                    for (_b in state.deployments)
                        _a.push(_b);
                    _i = 0;
                    _e.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 5];
                    deployment = _a[_i];
                    deploymentObject = __assign({}, state.deployments[deployment]);
                    creds = (_c = state.deployments[deployment]) === null || _c === void 0 ? void 0 : _c.credentials;
                    if (state.deployments[deployment].credentials) {
                        deploymentObject = __assign(__assign({}, deploymentObject), state.deployments[deployment].credentials);
                    }
                    if (!((creds === null || creds === void 0 ? void 0 : creds.webhook_enabled) && !((_d = creds === null || creds === void 0 ? void 0 : creds.emails) === null || _d === void 0 ? void 0 : _d.length))) return [3 /*break*/, 2];
                    maps_1.createAlert('Please enter Email Ids if Webhook is enabled', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    isValid_1 = false;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, platformDeployment_1.platformDeploymentSchemaV2
                        .validate(__assign({}, deploymentObject), { strict: true, abortEarly: false })["catch"](function (error) {
                        if (Array.isArray(error.errors)) {
                            error.errors.forEach(function (error) {
                                return maps_1.createAlert(error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            });
                        }
                        else if (error.errors) {
                            maps_1.createAlert(error.errors, null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        }
                        else {
                            maps_1.createAlert('Validation error! Please try again', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        }
                        isValid_1 = false;
                    })];
                case 3:
                    _e.sent();
                    _e.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 1];
                case 5:
                    if (!isValid_1) {
                        dispatch({ type: constants_1["default"].ActionTypes.TOGGLE_LOADER });
                        return [2 /*return*/];
                    }
                    apiPromise.push(api_1.API.businessV2
                        .saveDeployments(businessId, state.deployments)
                        .then(function (_a) {
                        var body = _a.body;
                        if (!body.success) {
                            maps_1.createAlert(body.error ||
                                'Error occurred while saving platform deployments', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return false;
                        }
                        dispatch({
                            type: constants_1["default"].ActionTypes.SET_DEPLOYMENT_EDITED_FALSE,
                        });
                        maps_1.createAlert('Successfully saved!', null, MogamboConstants_1.AlertTypes.POSITIVE);
                        return true;
                    })["catch"](function (err) {
                        maps_1.createAlert(err || 'Error occurred while saving platform deployments', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    }));
                    _e.label = 6;
                case 6:
                    if (!state.isSdkEdited) return [3 /*break*/, 8];
                    isValid_2 = true;
                    sdkConfig = state.sdkConfig, deployments = state.deployments;
                    return [4 /*yield*/, sdkConfiguration_1.sdkConfigurationSchemaV2
                            .validate(__assign({}, sdkConfig), { strict: true, abortEarly: false })["catch"](function (validationError) {
                            validationError.errors.forEach(function (error) {
                                return maps_1.createAlert(error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            });
                            isValid_2 = false;
                        })];
                case 7:
                    _e.sent();
                    if (!isValid_2) {
                        dispatch({ type: constants_1["default"].ActionTypes.TOGGLE_LOADER });
                        return [2 /*return*/];
                    }
                    commonConfig = {
                        gdpr: sdkConfig.gdpr.value,
                        showUserFeedback: sdkConfig.showUserFeedback.value,
                        showFeedbackPopoverInstantly: sdkConfig.showFeedbackPopoverInstantly.value,
                        userFeedbackQuestionNegative: sdkConfig.userFeedbackQuestionNegative,
                        userFeedbackQuestionPositive: sdkConfig.userFeedbackQuestionPositive,
                        userFeedbackTagsNegative: sdkConfig.userFeedbackTagsNegative,
                        userFeedbackTagsPositive: sdkConfig.userFeedbackTagsPositive,
                    };
                    sdkData = {
                        2: commonConfig,
                        5: {
                            primaryColor: sdkConfig.primaryColor.value,
                            primaryColor2: sdkConfig.primaryColor2,
                            widgetPositioning: sdkConfig.widgetPositioning.value,
                            mode: sdkConfig.mode.value,
                            botType: sdkConfig.botType.value,
                            disabled: sdkConfig.disabled.map(function (option) { return option.value; }),
                            fontSize: sdkConfig.fontSize,
                            customSignup: sdkConfig.customSignup.value,
                            customSignupIdentifier: sdkConfig.customSignupIdentifier,
                            baseUrl: sdkConfig.baseUrl,
                            customButton: sdkConfig.customButton.value,
                            chatIconConfig: sdkConfig.chatIconConfig,
                            languageIconConfig: sdkConfig.languageIconConfig,
                            omnichannelWidget: sdkConfig.omnichannelWidget,
                            customButtonIdentifier: sdkConfig.customButtonIdentifier,
                            voiceBotInitialInput: sdkConfig.voiceBotInitialInput,
                            gdpr: sdkConfig.gdpr.value,
                            showTypingSuggestions: sdkConfig.showTypingSuggestions.value,
                            disablePreviousButtons: sdkConfig.disablePreviousButtons.value,
                            showAgentChatHistory: sdkConfig.showAgentChatHistory.value,
                            showTimestamp: sdkConfig.showTimestamp.value,
                            showReferencesSection: sdkConfig.showReferencesSection.value,
                            showReferencesCaptionSection: sdkConfig.showReferencesCaptionSection.value,
                            disableBotPromptSound: sdkConfig.disableBotPromptSound.value,
                            botPromptSoundUrl: sdkConfig.botPromptSoundUrl,
                            enableMessageNotificationSound: sdkConfig.enableMessageNotificationSound.value,
                            messageNotificationSoundUrl: sdkConfig.messageNotificationSoundUrl,
                            botMessageSound: sdkConfig.botMessageSound,
                            userMessageSound: sdkConfig.userMessageSound,
                            showAgentData: sdkConfig.showAgentData.value,
                            skipAutoScrollToBottom: sdkConfig.skipAutoScrollToBottom.value,
                            openLinksUsing: sdkConfig.openLinksUsing.value,
                            showUserFeedback: sdkConfig.showUserFeedback.value,
                            showFeedbackPopoverInstantly: sdkConfig.showFeedbackPopoverInstantly.value,
                            userFeedbackTagsPositive: sdkConfig.userFeedbackTagsPositive,
                            userFeedbackTagsNegative: sdkConfig.userFeedbackTagsNegative,
                            userFeedbackQuestionPositive: sdkConfig.userFeedbackQuestionPositive,
                            userFeedbackQuestionNegative: sdkConfig.userFeedbackQuestionNegative,
                            language_config: sdkConfig.language_config,
                        },
                        6: commonConfig,
                        active: sdkConfig.businessActive,
                        hide_branding: !sdkConfig.showHaptikBranding,
                        image_url: sdkConfig.businessIcon,
                        cors_origins: sdkConfig.whiteListedDomains,
                    };
                    apiPromise.push(api_1.API.businessV2
                        .saveSDKConfig(businessId, sdkData)
                        .then(function (_a) {
                        var success = _a.success, response = _a.response;
                        if (!success) {
                            maps_1.createAlert(response.error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return false;
                        }
                        dispatch({ type: constants_1["default"].ActionTypes.SET_SDK_EDITED_FALSE });
                        maps_1.createAlert('Successfully saved!', null, MogamboConstants_1.AlertTypes.POSITIVE);
                        return true;
                    }));
                    _e.label = 8;
                case 8:
                    Promise.all(apiPromise)
                        .then(function (responses) {
                        dispatch({ type: constants_1["default"].ActionTypes.TOGGLE_LOADER });
                        if (!responses.filter(function (response) { return !response; }).length) {
                            dispatch({ type: constants_1["default"].ActionTypes.DATA_SAVED });
                        }
                    })["catch"](function (error) {
                        dispatch({ type: constants_1["default"].ActionTypes.TOGGLE_LOADER });
                        api_1.captureException(error);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1["default"].createElement(TabContainer_1["default"], { title: "Channels", marginTop: 44, isSaveDisabled: !state.isEdited, isLoaderActive: state.isLoaderActive, onSave: handleOnSave },
        react_1["default"].createElement("div", { className: "channels-credentials" },
            react_1["default"].createElement(button_1["default"], { onClick: function () {
                    return dispatch({
                        type: constants_1["default"].ActionTypes.TOGGLE_VIEW_CREDENTIALS_MODAL,
                    });
                } }, "View Credentials")),
        react_1["default"].createElement("div", { className: "channels" },
            react_1["default"].createElement(tabs_1["default"], { type: "vertical", value: state.activeTab }, constants_1["default"].TABS.CHANNEL_TABS.map(function (tab) { return (react_1["default"].createElement(tabs_1["default"].Item, { key: tab.path, value: tab.path, onClick: handleTabChange(false) }, tab.title)); })),
            !state.errorOccurredWhileFetching ? (getActiveTabInputs()) : (react_1["default"].createElement("div", { className: "channels-error" },
                react_1["default"].createElement("div", { className: "channels-error-message" }, "Error occurred while fetching data! Please reload."),
                react_1["default"].createElement(button_1["default"], { className: "channels-error-reload", type: button_1["default"].TYPES.PRIMARY, onClick: fetchChannelsData }, "Reload")))),
        react_1["default"].createElement(ViewCredentials_1["default"], { active: state.isViewCredentialsModalOpen, businessId: businessId, activePartner: activePartners.length ? activePartners[0] : { id: undefined }, onClose: function () {
                return dispatch({
                    type: constants_1["default"].ActionTypes.TOGGLE_VIEW_CREDENTIALS_MODAL,
                });
            } })));
};
exports["default"] = Channels;
